// extracted by mini-css-extract-plugin
module.exports = {"innerCard":"Timer_innerCard__2bKwY","timeInput":"Timer_timeInput__1GB0a","footer":"Timer_footer__1ppWk"};